import { Box, Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStudentSettings } from '../../settings/studentSettingsSlice';
import ContentLoader from '../../subcomponents/ContentLoader';
import AdminSettingBool from '../inputs/AdminSettingBool';

export default function StudentSettingsTab() {
    const dispatch = useDispatch();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { studentSettings, studentSettingsStatus } = useSelector((state) => state.settings.student);
    const { appSettings } = useSelector((state) => state.settings.app);

    useEffect(() => {
        dispatch(fetchStudentSettings());
    }, [dispatch]);

    return (
        <ContentLoader
            successCondition={studentSettingsStatus === "success"}
            errorCondition={studentSettingsStatus === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1} direction="column">
                        <AdminSettingBool
                            settingsType={"student"}
                            settingKey={"Student_EmailVerplicht"}
                            settingDefaultValue={studentSettings?.privateEmailRequired}
                            formLabel={resourceFinal[appLanguage].admin.STUDENT_EMAIL}
                            formText={resourceFinal[appLanguage].admin.STUDENT_EMAIL_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={12}
                        />
                        <AdminSettingBool
                            settingsType={"student"}
                            settingKey={"Student_PriveTelefoonVerplicht"}
                            settingDefaultValue={studentSettings?.privatePhoneRequired}
                            formLabel={resourceFinal[appLanguage].admin.STUDENT_PHONE_PRIVATE}
                            formText={resourceFinal[appLanguage].admin.STUDENT_PHONE_PRIVATE_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={12}
                        />
                        <AdminSettingBool
                            settingsType={"student"}
                            settingKey={"Student_WerkTelefoonVerplicht"}
                            settingDefaultValue={studentSettings?.workPhoneRequired}
                            formLabel={resourceFinal[appLanguage].admin.STUDENT_PHONE_WORK}
                            formText={resourceFinal[appLanguage].admin.STUDENT_PHONE_WORK_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={12}
                        />
                        {appSettings?.appVersion === 2 && (
                            <>
                                <AdminSettingBool
                                    settingsType={"student"}
                                    settingKey={"Student_IbanVerplicht"}
                                    settingDefaultValue={studentSettings?.ibanRequired}
                                    formLabel={resourceFinal[appLanguage].admin.STUDENT_IBAN}
                                    formText={resourceFinal[appLanguage].admin.STUDENT_IBAN_HTEXT}
                                    controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                    xsSize={12}
                                />
                                <AdminSettingBool
                                    settingsType={"student"}
                                    settingKey={"Student_PokVerplicht"}
                                    settingDefaultValue={studentSettings?.pokRequired}
                                    formLabel={resourceFinal[appLanguage].admin.STUDENT_POK}
                                    formText={resourceFinal[appLanguage].admin.STUDENT_POK_HTEXT}
                                    controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                                    xsSize={12}
                                />
                            </>
                        )}
                    </Grid>
                </Box>
            }
        />
    );
}
